import React, { useState, useEffect } from 'react';
import { FaTwitter, FaTiktok, FaYoutube, FaFacebookF, FaInstagram } from 'react-icons/fa';
import { SiThreads, SiCoinmarketcap, SiBinance } from 'react-icons/si';
import './home.css';

function Home() {
  const [language, setLanguage] = useState('en');
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  const languages = [
    // 🌍 글로벌 핵심 언어
    {code: 'en', name: '🇺🇸 English'},
    {code: 'zh', name: '🇨🇳 中文'},
    {code: 'es', name: '🇪🇸 Español'},
    {code: 'ja', name: '🇯🇵 日本語'},
    {code: 'ko', name: '🇰🇷 한국어'},
    {code: 'fr', name: '🇫🇷 Français'},
    {code: 'de', name: '🇩🇪 Deutsch'},
    {code: 'pt', name: '🇵🇹 Português'},
    {code: 'hi', name: '🇮🇳 हिन्दी'},
    {code: 'ar', name: '🇸🇦 العربية'},
    {code: 'ru', name: '🇷🇺 Русский'},

    // 📈 성장 가능성 높은 언어
    {code: 'tr', name: '🇹🇷 Türkçe'},
    {code: 'id', name: '🇮🇩 Bahasa Indonesia'},
    {code: 'vi', name: '🇻🇳 Tiếng Việt'},
    {code: 'it', name: '🇮🇹 Italiano'},
    {code: 'th', name: '🇹🇭 ภาษาไทย'},
    {code: 'pl', name: '🇵🇱 Polski'},
    {code: 'uk', name: '🇺🇦 Українська'},
    {code: 'nl', name: '🇳🇱 Nederlands'},

    // ➕ 보조적으로 유효한 언어 (선택적)
    {code: 'sv', name: '🇸🇪 Svenska'}, // 북유럽 고소득층
    {code: 'tl', name: '🇵🇭 Filipino'}, // 필리핀 (저가형 시장)
    {code: 'ms', name: '🇲🇾 Bahasa Melayu'}, // 말레이시아
    {code: 'bn', name: '🇧🇩 বাংলা'}, // 방글라데시
    {code: 'ta', name: '🇮🇳 தமிழ்'}, // 인도 남부
  ];

  const translations = {
    en: {
      heroTitle1: "I'm an AI developer",
      heroTitle2: "and a crypto strategy builder.",
      heroSubtitle: "Frustrated with complex tools,\nI built one I actually wanted to use.",
      service1: "Strategy-based Alerts",
      service1Desc: "Instead of guessing the market, get notified when your selected strategy detects a key signal. Customize alerts for each coin and strategy.",
      service2: "I'm investing too!",
      service2Desc: "I share the AI strategies. I'm investing alongside you and will transparently share how those strategies perform. See more on X.",
      service3: "Simplifying Quant Investing.",
      service3Desc: "Confused by market noise? I used to be too. So I built my own strategy engine to make data-driven investing accessible and clear.",
      mainTitle: "Get strategy-based signals\nfor smarter investing decisions.",
      comparisonTitle: "Compared to the insights you'll get\nfrom using DeepQuant",
      comparisonSubtitle: "$2.99/month is a no-brainer.",
      holdingTitle: "Passive holding shows\nthese historical results",
      tradingTitle: "Strategic trading with DeepQuant\ncan lead to better performance",
    },
    ko: {
      heroTitle1: "AI 개발자가 만든 전략 기반",
      heroTitle2: "코인/주식 시그널 알림 앱",
      heroSubtitle: "복잡하고 불편한 서비스에 지쳐,\n제가 직접 쓰고 싶은 앱을 만들었습니다.",
      service1: "전략 기반 알림",
      service1Desc: "시장 흐름을 예측하기 어렵다면,\n지표가 감지될 때 알림을 받아보세요.\n코인과 전략별 맞춤 설정이 가능합니다.",
      service2: "저희도 함께 투자합니다!",
      service2Desc: "저희가 직접 사용하는 AI 전략을 공유합니다.\n실제 수익률도 투명하게 공개할 예정이에요.\n자세한 내용은 X에서 확인하세요.",
      service3: "복잡한 퀀트 투자를 심플하게.",
      service3Desc: "시장에 휩쓸리는 투자가 어려우셨나요?\n저희도 같은 고민 끝에\n직접 전략 분석 엔진을 만들었습니다.",
      mainTitle: "전략 기반 시그널로\n더 똑똑한 투자 결정을 해보세요.",
      comparisonTitle: "DeepQuant이 제공하는 인사이트 대비",
      comparisonSubtitle: "월 4,400원은 아깝지 않은 가격입니다!",
      holdingTitle: "단순 홀딩 전략의\n과거 성과 수익률",
      tradingTitle: "DeepQuant 전략 기반의\n매매 시뮬레이션 수익률",
    },
    zh: {
      heroTitle1: "AI开发者构建的基于策略的",
      heroTitle2: "加密货币/股票信号提醒应用",
      heroSubtitle: "厌倦了复杂不便的服务，\n所以我开发了自己想用的应用。",
      service1: "基于策略的提醒",
      service1Desc: "如果难以预测市场走向，\n当指标被检测到时接收提醒。\n可针对货币和策略进行个性化设置。",
      service2: "我们也一起投资！",
      service2Desc: "我们分享自己使用的AI策略。\n也将透明地公开实际收益率。\n详情请在X上查看。",
      service3: "让复杂的量化投资变得简单。",
      service3Desc: "被市场波动困扰的投资很困难吗？\n我们也有同样的困扰，\n所以直接开发了策略分析引擎。",
      mainTitle: "通过基于策略的信号\n做出更聪明的投资决策。",
      comparisonTitle: "相比DeepQuant提供的洞察",
      comparisonSubtitle: "每月25元绝对物有所值！",
      holdingTitle: "简单持有策略的\n历史表现收益率",
      tradingTitle: "基于DeepQuant策略的\n交易模拟收益率",
    },
    ja: {
      heroTitle1: "AI開発者が作った戦略ベースの",
      heroTitle2: "仮想通貨/株式シグナル通知アプリ",
      heroSubtitle: "複雑で使いにくいサービスに疲れて、\n自分が使いたいアプリを作りました。",
      service1: "戦略ベースの通知",
      service1Desc: "市場の流れを予測するのが難しいなら、\n指標が検出されたときに通知を受け取りましょう。\nコインと戦略別のカスタム設定が可能です。",
      service2: "私たちも一緒に投資します！",
      service2Desc: "私たちが実際に使用するAI戦略を共有します。\n実際の収益率も透明に公開する予定です。\n詳細はXでご確認ください。",
      service3: "複雑なクオント投資をシンプルに。",
      service3Desc: "市場に振り回される投資が困難でしたか？\n私たちも同じ悩みを抱えて\n直接戦略分析エンジンを作りました。",
      mainTitle: "戦略ベースのシグナルで\nより賢い投資判断をしましょう。",
      comparisonTitle: "DeepQuantが提供するインサイトと比較して",
      comparisonSubtitle: "月額500円は決して高くない価格です！",
      holdingTitle: "単純なホールド戦略の\n過去のパフォーマンス収益率",
      tradingTitle: "DeepQuant戦略ベースの\n取引シミュレーション収益率",
    },
    es: {
      heroTitle1: "Aplicación de señales cripto/acciones",
      heroTitle2: "basada en estrategias hecha por desarrollador IA",
      heroSubtitle: "Cansado de servicios complejos e inconvenientes,\ncreé la app que realmente quería usar.",
      service1: "Alertas basadas en estrategias",
      service1Desc: "Si es difícil predecir el flujo del mercado,\nrecibe alertas cuando se detecten indicadores.\nConfiguración personalizada por moneda y estrategia.",
      service2: "¡Nosotros también invertimos!",
      service2Desc: "Compartimos las estrategias de IA que usamos.\nTambién publicaremos transparentemente las tasas de rendimiento reales.\nMás detalles en X.",
      service3: "Simplificando la inversión cuantitativa compleja.",
      service3Desc: "¿Era difícil invertir siendo arrastrado por el mercado?\nNosotros también tuvimos la misma preocupación\ny creamos directamente un motor de análisis de estrategias.",
      mainTitle: "Toma decisiones de inversión más inteligentes\ncon señales basadas en estrategias.",
      comparisonTitle: "Comparado con las ideas que obtienes\nusando DeepQuant",
      comparisonSubtitle: "€2.99/mes no es nada caro!",
      holdingTitle: "Resultados históricos de\nestratega de holding pasivo",
      tradingTitle: "Tasa de rendimiento de simulación\nde trading basado en estrategias DeepQuant",
    },
    fr: {
      heroTitle1: "Application de signaux crypto/actions",
      heroTitle2: "basée sur des stratégies par développeur IA",
      heroSubtitle: "Fatigué des services complexes et gênants,\nj'ai créé l'app que je voulais vraiment utiliser.",
      service1: "Alertes basées sur des stratégies",
      service1Desc: "S'il est difficile de prédire le flux du marché,\nrecevez des alertes quand les indicateurs sont détectés.\nConfiguration personnalisée par devise et stratégie.",
      service2: "Nous investissons aussi !",
      service2Desc: "Nous partageons les stratégies IA que nous utilisons.\nNous publierons aussi transparemment les taux de rendement réels.\nPlus de détails sur X.",
      service3: "Simplifier l'investissement quantitatif complexe.",
      service3Desc: "Était-il difficile d'investir en étant emporté par le marché ?\nNous avons eu la même préoccupation\net avons créé directement un moteur d'analyse de stratégies.",
      mainTitle: "Prenez des décisions d'investissement plus intelligentes\navec des signaux basés sur des stratégies.",
      comparisonTitle: "Comparé aux insights que vous obtenez\nen utilisant DeepQuant",
      comparisonSubtitle: "2.99€/mois n'est pas cher !",
      holdingTitle: "Résultats historiques de\nstratégie de holding passif",
      tradingTitle: "Taux de rendement de simulation\nde trading basé sur les stratégies DeepQuant",
    },
    de: {
      heroTitle1: "Strategiebasierte Krypto/Aktien-",
      heroTitle2: "Signal-App von KI-Entwickler",
      heroSubtitle: "Müde von komplexen und unbequemen Diensten,\nhabe ich die App erstellt, die ich wirklich nutzen wollte.",
      service1: "Strategiebasierte Warnungen",
      service1Desc: "Wenn es schwierig ist, den Marktfluss vorherzusagen,\nerhalten Sie Warnungen, wenn Indikatoren erkannt werden.\nPersonalisierte Einstellungen nach Währung und Strategie.",
      service2: "Wir investieren auch!",
      service2Desc: "Wir teilen die KI-Strategien, die wir verwenden.\nWir werden auch transparent die tatsächlichen Renditeraten veröffentlichen.\nMehr Details auf X.",
      service3: "Komplexe Quant-Investitionen vereinfachen.",
      service3Desc: "War es schwierig zu investieren, wenn man vom Markt mitgerissen wird?\nWir hatten dieselbe Sorge\nund haben direkt eine Strategieanalyse-Engine erstellt.",
      mainTitle: "Treffen Sie intelligentere Investitionsentscheidungen\nmit strategiebasierten Signalen.",
      comparisonTitle: "Verglichen mit den Einblicken, die Sie\ndurch DeepQuant erhalten",
      comparisonSubtitle: "2,99€/Monat ist nicht teuer!",
      holdingTitle: "Historische Ergebnisse der\npassiven Holding-Strategie",
      tradingTitle: "Rendite-Simulation des\nDeepQuant-strategiebasierten Handels",
    },
    pt: {
      heroTitle1: "App de sinais cripto/ações",
      heroTitle2: "baseado em estratégias por desenvolvedor IA",
      heroSubtitle: "Cansado de serviços complexos e inconvenientes,\ncriei o app que realmente queria usar.",
      service1: "Alertas baseados em estratégias",
      service1Desc: "Se é difícil prever o fluxo do mercado,\nreceba alertas quando indicadores forem detectados.\nConfiguração personalizada por moeda e estratégia.",
      service2: "Nós também investimos!",
      service2Desc: "Compartilhamos as estratégias de IA que usamos.\nTambém publicaremos transparentemente as taxas de retorno reais.\nMais detalhes no X.",
      service3: "Simplificando investimentos quantitativos complexos.",
      service3Desc: "Era difícil investir sendo arrastado pelo mercado?\nTivemos a mesma preocupação\ne criamos diretamente um motor de análise de estratégias.",
      mainTitle: "Tome decisões de investimento mais inteligentes\ncom sinais baseados em estratégias.",
      comparisonTitle: "Comparado aos insights que você obtém\nusando DeepQuant",
      comparisonSubtitle: "R$15/mês não é caro!",
      holdingTitle: "Resultados históricos da\nestratégia de holding passivo",
      tradingTitle: "Taxa de retorno de simulação\nde negociação baseada em estratégias DeepQuant",
    },
    hi: {
      heroTitle1: "AI डेवलपर द्वारा बनाया गया रणनीति आधारित",
      heroTitle2: "क्रिप्टो/स्टॉक सिग्नल अलर्ट ऐप",
      heroSubtitle: "जटिल और असुविधाजनक सेवाओं से थक कर,\nमैंने वह ऐप बनाया जिसे मैं वास्तव में उपयोग करना चाहता था।",
      service1: "रणनीति आधारित अलर्ट",
      service1Desc: "यदि बाजार के प्रवाह का अनुमान लगाना कठिन है,\nतो संकेतक का पता चलने पर अलर्ट प्राप्त करें।\nसिक्के और रणनीति के अनुसार व्यक्तिगत सेटिंग संभव है।",
      service2: "हम भी निवेश करते हैं!",
      service2Desc: "हम उन AI रणनीतियों को साझा करते हैं जिनका हम उपयोग करते हैं।\nवास्तविक रिटर्न दरों को भी पारदर्शी रूप से प्रकाशित करेंगे।\nअधिक विवरण X पर देखें।",
      service3: "जटिल क्वांट निवेश को सरल बनाना।",
      service3Desc: "क्या बाजार में बहने वाला निवेश कठिन था?\nहमारी भी यही चिंता थी\nऔर हमने सीधे रणनीति विश्लेषण इंजन बनाया।",
      mainTitle: "रणनीति आधारित सिग्नल के साथ\nअधिक स्मार्ट निवेश निर्णय लें।",
      comparisonTitle: "DeepQuant का उपयोग करके आपको मिलने वाली\nअंतर्दृष्टि की तुलना में",
      comparisonSubtitle: "₹250/महीना महंगा नहीं है!",
      holdingTitle: "निष्क्रिय होल्डिंग रणनीति के\nऐतिहासिक परिणाम",
      tradingTitle: "DeepQuant रणनीति आधारित\nट्रेडिंग सिमुलेशन रिटर्न दर",
    },
    ar: {
      heroTitle1: "تطبيق إشارات العملات المشفرة/الأسهم",
      heroTitle2: "القائم على الاستراتيجيات من مطور الذكاء الاصطناعي",
      heroSubtitle: "تعبت من الخدمات المعقدة وغير المريحة،\nلذلك أنشأت التطبيق الذي أردت استخدامه حقاً.",
      service1: "تنبيهات قائمة على الاستراتيجيات",
      service1Desc: "إذا كان من الصعب التنبؤ بتدفق السوق،\nاحصل على تنبيهات عند اكتشاف المؤشرات.\nإعداد شخصي حسب العملة والاستراتيجية.",
      service2: "نحن نستثمر أيضاً!",
      service2Desc: "نشارك استراتيجيات الذكاء الاصطناعي التي نستخدمها.\nسننشر أيضاً معدلات العائد الفعلية بشفافية.\nمزيد من التفاصيل على X.",
      service3: "تبسيط الاستثمار الكمي المعقد.",
      service3Desc: "هل كان من الصعب الاستثمار عند الانجراف مع السوق؟\nكان لدينا نفس القلق\nوأنشأنا محرك تحليل الاستراتيجيات مباشرة.",
      mainTitle: "اتخذ قرارات استثمارية أكثر ذكاءً\nبإشارات قائمة على الاستراتيجيات.",
      comparisonTitle: "مقارنة بالرؤى التي تحصل عليها\nمن استخدام DeepQuant",
      comparisonSubtitle: "11 ريال/شهر ليس غالياً!",
      holdingTitle: "النتائج التاريخية لاستراتيجية\nالاحتفاظ السلبي",
      tradingTitle: "معدل عائد محاكاة التداول\nالقائم على استراتيجيات DeepQuant",
    },
    ru: {
      heroTitle1: "Приложение криптовалютных/фондовых сигналов",
      heroTitle2: "на основе стратегий от ИИ-разработчика",
      heroSubtitle: "Устав от сложных и неудобных сервисов,\nя создал приложение, которое действительно хотел использовать.",
      service1: "Уведомления на основе стратегий",
      service1Desc: "Если сложно предсказать поток рынка,\nполучайте уведомления при обнаружении индикаторов.\nПерсональная настройка по валюте и стратегии.",
      service2: "Мы тоже инвестируем!",
      service2Desc: "Мы делимся ИИ-стратегиями, которые используем.\nТакже прозрачно будем публиковать реальные доходности.\nПодробнее в X.",
      service3: "Упрощение сложных квант-инвестиций.",
      service3Desc: "Было сложно инвестировать, следуя за рынком?\nУ нас была та же проблема\nи мы создали движок анализа стратегий.",
      mainTitle: "Принимайте более умные инвестиционные решения\nс сигналами на основе стратегий.",
      comparisonTitle: "По сравнению с инсайтами, которые вы получаете\nиспользуя DeepQuant",
      comparisonSubtitle: "250₽/месяц не дорого!",
      holdingTitle: "Исторические результаты\nпассивной стратегии удержания",
      tradingTitle: "Доходность симуляции торговли\nна основе стратегий DeepQuant",
    },
    tr: {
      heroTitle1: "Yapay zekâ geliştiricisinin oluşturduğu strateji tabanlı",
      heroTitle2: "kripto/hisse sinyal uygulaması",
      heroSubtitle: "Karmaşık ve kullanışsız servislerden yoruldum,\nbenim gerçekten kullanmak istediğim uygulamayı yaptım.",
      service1: "Strateji Tabanlı Uyarılar",
      service1Desc: "Piyasanın akışını tahmin etmek zorsa,\nseçilen göstergeniz tetiklendiğinde bildirim alın.\nCoin ve strateji bazlı özelleştirme imkânı.",
      service2: "Biz de yatırım yapıyoruz!",
      service2Desc: "Kullandığımız AI stratejilerini paylaşıyoruz.\nGerçek getiri oranlarını şeffaf şekilde yayınlayacağız.\nDetaylar için X'e bakın.",
      service3: "Karmaşık kuant yatırımını basitleştirin.",
      service3Desc: "Piyasa gürültüsünde kaybolmak zor mu?\nBiz de aynı sorunu yaşadık ve\nkendi strateji motorumuzu oluşturduk.",
      mainTitle: "Strateji tabanlı sinyallerle\ndaha akıllı yatırım kararları alın.",
      comparisonTitle: "DeepQuant kullanarak elde edeceğiniz içgörülerle\nkarşılaştırıldığında",
      comparisonSubtitle: "Aylık ₺60 çok uygun!",
      holdingTitle: "Pasif tutma stratejisinin\ntarihî getiri oranı",
      tradingTitle: "DeepQuant stratejili\nticaret simülasyonu getirisi",
    },
    id: {
      heroTitle1: "Aplikasi sinyal kripto/saham",
      heroTitle2: "berbasis strategi dari pengembang AI",
      heroSubtitle: "Lelah dengan layanan yang rumit,\nSaya membuat aplikasi yang benar-benar ingin saya gunakan.",
      service1: "Notifikasi berbasis strategi",
      service1Desc: "Sulit memprediksi pasar?\nDapatkan notifikasi saat indikator terdeteksi.\nPengaturan khusus per koin & strategi.",
      service2: "Kami juga berinvestasi!",
      service2Desc: "Kami berbagi strategi AI yang kami pakai.\nHasil nyata akan dipublikasi secara transparan.\nLihat detail di X.",
      service3: "Menyederhanakan investasi kuant rumit.",
      service3Desc: "Bingung oleh hiruk pikuk pasar?\nKami juga begitu—maka kami membangun engine strategi sendiri.",
      mainTitle: "Ambil keputusan investasi lebih cerdas\ndengan sinyal berbasis strategi.",
      comparisonTitle: "Dibanding insight yang Anda dapat\ndengan DeepQuant",
      comparisonSubtitle: "Rp45k/bulan sangat worth it!",
      holdingTitle: "Hasil historis strategi\nmenahan aset",
      tradingTitle: "Hasil simulasi trading\nbase sa DeepQuant strategies",
    },
    vi: {
      heroTitle1: "Ứng dụng tín hiệu tiền mã hoá/cổ phiếu",
      heroTitle2: "dựa trên chiến lược do lập trình viên AI phát triển",
      heroSubtitle: "Mệt mỏi với các dịch vụ phức tạp,\ntôi đã tạo nên ứng dụng mình thật sự muốn dùng.",
      service1: "Thông báo dựa trên chiến lược",
      service1Desc: "Khó dự đoán thị trường?\nNhận thông báo khi chỉ báo được kích hoạt.\nTuỳ chỉnh theo coin & chiến lược.",
      service2: "Chúng tôi cũng đầu tư!",
      service2Desc: "Chia sẻ chiến lược AI chúng tôi dùng.\nTỷ suất thực sẽ được công khai minh bạch.\nXem thêm trên X.",
      service3: "Đơn giản hoá đầu tư định lượng phức tạp.",
      service3Desc: "Bối rối bởi biến động thị trường?\nChúng tôi cũng vậy nên đã xây engine chiến lược riêng.",
      mainTitle: "Gumawa ng mas matalinong desisyon sa investment\nsa pamamagitan ng strategy signals.",
      comparisonTitle: "Kumpara sa insights mula sa DeepQuant",
      comparisonSubtitle: "₱149/buwan sulit!",
      holdingTitle: "Historical returns ng\npassive holding strategy",
      tradingTitle: "Returns ng simulated trading\nbase sa DeepQuant strategies",
    },
    it: {
      heroTitle1: "App di segnali cripto/azioni",
      heroTitle2: "basata su strategie di uno sviluppatore AI",
      heroSubtitle: "Stufo di servizi complessi,\nho creato l'app che volevo davvero usare.",
      service1: "Avvisi basati su strategie",
      service1Desc: "Difficile prevedere il mercato?\nRicevi avvisi quando vengono rilevati indicatori.\nPersonalizza per moneta e strategia.",
      service2: "Investiamo anche noi!",
      service2Desc: "Condividiamo le strategie AI che usiamo.\nRenderemo pubblici i rendimenti reali in modo trasparente.\nMaggiori dettagli su X.",
      service3: "Semplificare il trading quantitativo complesso.",
      service3Desc: "Confuso dal rumore di mercato?\nAnche noi, quindi abbiamo creato un nostro motore strategico.",
      mainTitle: "Prendi decisioni di investimento più intelligenti\ncon segnali basati su strategie.",
      comparisonTitle: "Rispetto alle insight ottenute\ncon DeepQuant",
      comparisonSubtitle: "€2,99/mese è un affare!",
      holdingTitle: "Performance storica della\nstrategia buy-and-hold",
      tradingTitle: "Rendimento simulato del trading\nbasato su strategie DeepQuant",
    },
    th: {
      heroTitle1: "แอปสัญญาณคริปโต/หุ้น",
      heroTitle2: "เชิงกลยุทธ์โดยนักพัฒนา AI",
      heroSubtitle: "เบื่อกับบริการซับซ้อน\nจึงสร้างแอปที่อยากใช้จริง ๆ",
      service1: "การแจ้งเตือนตามกลยุทธ์",
      service1Desc: "คาดการณ์ตลาดยาก?\nรับแจ้งเมื่อพบสัญญาณตัวชี้วัด\nปรับแต่งได้ตามเหรียญและกลยุทธ์",
      service2: "พวกเราก็ลงทุนด้วย!",
      service2Desc: "แบ่งปันกลยุทธ์ AI ที่ใช้จริง\nเผยผลตอบแทนจริงอย่างโปร่งใส\nดูรายละเอียดที่ X",
      service3: "ทำให้ควอนท์ลงทุนซับซ้อนง่ายขึ้น",
      service3Desc: "สับสนกับเสียงรบกวนตลาดใช่ไหม?\nเราก็เช่นกัน จึงสร้างเอนจินกลยุทธ์ของตัวเอง",
      mainTitle: "ตัดสินใจลงทุนฉลาดขึ้น\nด้วยสัญญาณเชิงกลยุทธ์",
      comparisonTitle: "เทียบกับอินไซต์ที่ได้จาก DeepQuant",
      comparisonSubtitle: "₹199/มีนาคม คุ้มค่า!",
      holdingTitle: "ผลลัพธ์ประวัติศาสตร์ของ\nกลยุทธ์ถือยาว",
      tradingTitle: "ผลตอบแทนจำลอง\nจากกลยุทธ์ DeepQuant",
    },
    pl: {
      heroTitle1: "Aplikacja sygnałów krypto/akcji",
      heroTitle2: "oparta na strategiach od developera AI",
      heroSubtitle: "Zmęczony złożonymi usługami,\nstworzyłem aplikację, której naprawdę chciałem używać.",
      service1: "Alerty oparte na strategiach",
      service1Desc: "Trudno przewidzieć rynek?\nOtrzymuj alerty, gdy wykryto wskaźnik.\nPersonalizuj dla monety i strategii.",
      service2: "My też inwestujemy!",
      service2Desc: "Udostępniamy strategie AI, których używamy.\nRzeczywiste stopy zwrotu będą publikowane przejrzyście.\nSzczegóły na X.",
      service3: "Uproszczenie złożonych inwestycji ilościowych.",
      service3Desc: "Zdezorientowany szumem rynkowym?\nMy też, więc zbudowaliśmy własny silnik strategii.",
      mainTitle: "Dokonuj mądrzejszych decyzji inwestycyjnych\ndzięki sygnałom strategicznym.",
      comparisonTitle: "W porównaniu do wglądu z DeepQuant",
      comparisonSubtitle: "12zł/mies. to okazja!",
      holdingTitle: "Historyczne wyniki strategii\ntrzymania",
      tradingTitle: "Zwrot z symulacji tradingu\nopartego na DeepQuant",
    },
    uk: {
      heroTitle1: "Додаток сигналів крипто/акцій",
      heroTitle2: "на основі стратегій від розробника ШІ",
      heroSubtitle: "Втомившись від складних сервісів,\nя створив застосунок, який справді хотів використовувати.",
      service1: "Сповіщення на основі стратегій",
      service1Desc: "Важко передбачити ринок?\nОтримуйте сповіщення, коли індикатор спрацьовує.\nНалаштування за монетою та стратегією.",
      service2: "Ми також інвестуємо!",
      service2Desc: "Ділимося стратегіями ШІ, що використовуємо.\nСправжні прибутки будемо публікувати прозоро.\nДетальніше в X.",
      service3: "Спрощення складних кількісних інвестицій.",
      service3Desc: "Заплутались у ринковому шумі?\nМи також, тому створили власний движок стратегій.",
      mainTitle: "Приймайте розумніші інвестиційні рішення\nз сигналами на основі стратегій.",
      comparisonTitle: "Порівняно з інсайтами, які дає DeepQuant",
      comparisonSubtitle: "99₴/міс — це вигідно!",
      holdingTitle: "Історичні результати\nстратегії утримання",
      tradingTitle: "Доходність симуляції трейдингу\nна базі стратегій DeepQuant",
    },
    nl: {
      heroTitle1: "Strategie-gebaseerde crypto/aandelen",
      heroTitle2: "signaal-app door AI-ontwikkelaar",
      heroSubtitle: "Moe van complexe diensten,\nmaakte ik de app die ik echt wilde gebruiken.",
      service1: "Strategie-gebaseerde meldingen",
      service1Desc: "Moeilijk om de markt te voorspellen?\nOntvang meldingen wanneer indicatoren worden gedetecteerd.\nAanpasbaar per munt en strategie.",
      service2: "Wij investeren ook!",
      service2Desc: "We delen de AI-strategieën die we gebruiken.\nWe zullen echte rendementen transparant publiceren.\nMeer info op X.",
      service3: "Complexe kwant-investeringen vereenvoudigen",
      service3Desc: "Verdwaald in marktlawaai?\nWij ook, dus bouwden onze eigen strategie-engine.",
      mainTitle: "Neem slimmere investeringsbeslissingen\nmet strategie-gebaseerde signalen.",
      comparisonTitle: "Vergeleken met inzichten die je krijgt\nmet DeepQuant",
      comparisonSubtitle: "€2,99/maand is een koopje!",
      holdingTitle: "Historische resultaten van\nvasthoudstrategie",
      tradingTitle: "Rendement simulatiehandel\nop DeepQuant-strategieën",
    },
    sv: {
      heroTitle1: "Strategibaserad krypto/aktie-",
      heroTitle2: "signalapp av AI-utvecklare",
      heroSubtitle: "Trött på komplexa tjänster,\nbyggde jag appen jag verkligen ville använda.",
      service1: "Strategibaserade aviseringar",
      service1Desc: "Svårt att förutsäga marknaden?\nFå aviseringar när indikatorer upptäcks.\nAnpassa per mynt och strategi.",
      service2: "Vi investerar också!",
      service2Desc: "Vi delar AI-strategierna vi använder.\nVi kommer även att publicera faktiska avkastningar transparent.\nMer info på X.",
      service3: "Förenkla komplex kvantinvestering",
      service3Desc: "Förvirrad av marknadsbrus?\nVi också, därför byggde vi en egen strategi-motor.",
      mainTitle: "Gör smartare investeringsbeslut\nmed strategibaserade signaler.",
      comparisonTitle: "Jämfört med insikter du får\nmed DeepQuant",
      comparisonSubtitle: "35 kr/mån är ett kap!",
      holdingTitle: "Historisk avkastning för\npassiv strategi",
      tradingTitle: "Avkastning från simulerad handel\nbaserad på DeepQuant-strategier",
    },
    tl: {
      heroTitle1: "App ng crypto/stock signal",
      heroTitle2: "na batay sa strategy ng AI developer",
      heroSubtitle: "Pagod na sa komplikadong serbisyo,\ngumawa ako ng app na gusto ko talagang gamitin.",
      service1: "Mga alertong batay sa strategy",
      service1Desc: "Mahirap hulaan ang galaw ng merkado?\nMakakuha ng alerto kapag may indicator.\nI-custom ayon sa coin at strategy.",
      service2: "Nag-iinvest din kami!",
      service2Desc: "Ibinabahagi namin ang AI strategies na gamit namin.\nIpo-post din nang tapat ang totoong returns.\nTingnan pa sa X.",
      service3: "Pinapasimple ang komplikadong quant investing",
      service3Desc: "Nalilito sa ingay ng merkado?\nKami rin, kaya gumawa ng sariling strategy engine.",
      mainTitle: "Gumawa ng mas matalinong desisyon sa investment\nsa pamamagitan ng strategy signals.",
      comparisonTitle: "Kumpara sa insights mula sa DeepQuant",
      comparisonSubtitle: "₱149/buwan sulit!",
      holdingTitle: "Historical returns ng\npassive holding strategy",
      tradingTitle: "Returns ng simulated trading\nbase sa DeepQuant strategies",
    },
    ms: {
      heroTitle1: "Aplikasi isyarat kripto/saham",
      heroTitle2: "berasaskan strategi daripada pembangun AI",
      heroSubtitle: "Penat dengan perkhidmatan yang rumit,\nSaya bina aplikasi yang benar-benar ingin saya guna.",
      service1: "Makluman berasaskan strategi",
      service1Desc: "Sukar meramal pasaran?\nDapatkan makluman apabila indikator dikesan.\nSuai kustom ikut coin & strategi.",
      service2: "Kami juga melabur!",
      service2Desc: "Kami kongsi strategi AI yang kami guna.\nKadar pulangan sebenar akan diterbitkan secara telus.\nButiran lanjut di X.",
      service3: "Mempermudah pelaburan kuantitatif kompleks",
      service3Desc: "Keliru dengan hingar pasaran?\nKami juga, jadi bina enjin strategi sendiri.",
      mainTitle: "Buat keputusan pelaburan lebih bijak\ndengan isyarat strategi.",
      comparisonTitle: "Berbanding insight yang anda dapat\nmelalui DeepQuant",
      comparisonSubtitle: "RM9.90/bulan sangat berbaloi!",
      holdingTitle: "Pulangan sejarah strategi\npegang pasif",
      tradingTitle: "Pulangan simulasi dagangan\nberasaskan strategi DeepQuant",
    },
    bn: {
      heroTitle1: "কৌশলভিত্তিক ক্রিপ্টো/স্টক সিগনাল অ্যাপ",
      heroTitle2: "AI ডেভেলপার দ্বারা নির্মিত",
      heroSubtitle: "জটিল সেবায় ক্লান্ত,\nআমি এমন একটি অ্যাপ তৈরি করেছি যা আমি সত্যিই ব্যবহার করতে চাই।",
      service1: "কৌশলভিত্তিক সতর্কতা",
      service1Desc: "বাজারের গতি অনুমান করা কঠিন?\nইন্ডিকেটর শনাক্ত হলে সতর্কতা পান।\nকয়েন ও কৌশলভিত্তিক কাস্টমাইজেশন।",
      service2: "আমরাও বিনিয়োগ করছি!",
      service2Desc: "আমরা ব্যবহৃত AI কৌশল শেয়ার করছি।\nআসল রিটার্ন স্বচ্ছভাবে প্রকাশ করব।\nবিস্তারিত X-এ।",
      service3: "জটিল কোয়ান্ট বিনিয়োগ সরলীকরণ",
      service3Desc: "বাজারের শোরগোলে বিভ্রান্ত?\nআমরাও তাই, তাই নিজস্ব কৌশল ইঞ্জিন বানিয়েছি।",
      mainTitle: "কৌশলভিত্তিক সিগনালের সাথে\nআরও স্মার্ট বিনিয়োগ সিদ্ধান্ত নিন।",
      comparisonTitle: "DeepQuant থেকে প্রাপ্ত ইনসাইটের তুলনায়",
      comparisonSubtitle: "৳199/মাস সস্তা!",
      holdingTitle: "প্যাসিভ হোল্ডিং কৌশলের\nইতিহাসগত ফলাফল",
      tradingTitle: "DeepQuant কৌশলভিত্তিক\nট্রেডিং সিমুলেশনের রিটার্ন",
    },
    ta: {
      heroTitle1: "AI உருவாக்கிய தந்திரம் சார்ந்த",
      heroTitle2: "கிரிப்டோ/பங்கு சிக்னல் ஆப்",
      heroSubtitle: "சிக்கலான சேவைகளால் தளைத்துவிட்டு,\nநான் உண்மையில் பயன்படுத்த விரும்பிய ஆப்பை உருவாக்கினேன்.",
      service1: "தந்திரம் சார்ந்த அறிவிப்புகள்",
      service1Desc: "சந்தையின் இயக்கத்தை கணிக்க க஠ிநம்?\nசுட்டிகாட்டி கிரியா செய்தால் அறிவிப்பு பெறுங்கள்.\nநாணயமும் தந்திரம் அடிப்படையாக தரவமைப்பு.",
      service2: "நாங்களும் முதலீடு செய்கிறோம்!",
      service2Desc: "நாங்கள் பயன்படும் AI தந்திரங்களை பகிர்கிறோம்.\nஉண்மையான வருமான விகிதங்களை வெளிப்படையாக வெளியிடுவோம்.\nகூடுதல் விவரங்கள் X-இல்.",
      service3: "சிக்கலான க்வாண்ட் முதலீட்டை எளிமையாக்கல்",
      service3Desc: "சந்தை இரைச்சலில் குழப்பமா?\nநாமும் அதே நிலையில், எனவே தந்திரம் என்ஜினை உருவாக்கினோம்.",
      mainTitle: "தந்திரம் சார்ந்த சிக்னல்களுடன்\nஅதிக புத்திசாலி முதலீட்டுத் தேர்வுகள் செய்யுங்கள்.",
      comparisonTitle: "DeepQuant வழங்கும் உள்ளடக்கங்களுடன் ஒப்பிடுகையில்",
      comparisonSubtitle: "₹199/மாதம் மிகவும் மலிவு!",
      holdingTitle: "பாசிட்டிவ் ஹோல்டிங் தந்திரத்தின்\nவரலாற்று பயன்",
      tradingTitle: "DeepQuant தந்திர சார்ந்த\nவர்த்தக சிமுலேஷன் வருமானம்",
    }
  };

  const selectLanguage = (langCode) => {
    setLanguage(langCode);
    setIsLanguageDropdownOpen(false);
  };

  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };

  const getCurrentLanguageName = () => {
    const currentLang = languages.find(lang => lang.code === language);
    return currentLang ? currentLang.name : '🇺🇸 English';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isLanguageDropdownOpen && !event.target.closest('.language-dropdown')) {
        setIsLanguageDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isLanguageDropdownOpen]);

  const t = translations[language] || translations.en;

  return (
    <div className="App">
      <nav className="navbar">
        <div className="logo">
          <img src={require('../images/icon.png')} alt="DeepQuant" />
          <span>DeepQuant</span>
        </div>
        <div className="language-selector">
          <button className="language-btn" onClick={toggleLanguageDropdown}>
            {getCurrentLanguageName()}
            <span className={`dropdown-arrow ${isLanguageDropdownOpen ? 'open' : ''}`}>▼</span>
          </button>
          {isLanguageDropdownOpen && (
            <div className="language-dropdown">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  className={`language-option ${language === lang.code ? 'active' : ''}`}
                  onClick={() => selectLanguage(lang.code)}
                >
                  {lang.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </nav>

      <section id="home" className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              <span className="purple-text">{t.heroTitle1}</span>
              <br />
              <span className="purple-text">{t.heroTitle2}</span>
            </h1>
            <h2 className="blue-text">
              {t.heroSubtitle}
            </h2>
            <div className="app-stores">
              <a href="https://apps.apple.com/kr/app/deepquant-%EB%94%A5%ED%80%80%ED%8A%B8-ai%EB%A5%BC-%EC%9D%B4%EC%9A%A9%ED%95%9C-%ED%88%AC%EC%9E%90/id6744814847" className="store-button" target="_blank" rel="noopener noreferrer">
                <img src={require('../images/appStore.png')} alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.deepquant&pcampaignid=web_share" className="store-button" target="_blank" rel="noopener noreferrer">
                <img src={require('../images/playStore.png')} alt="Get it on Google Play" />
              </a>
            </div>
          </div>
          <div className="hero-image">
            <img src={require('../images/appImage.png')} alt="DeepQuant App" className="phone-mockup" />
          </div>
        </div>
      </section>

      <section id="services" className="services-section">
        <h1 className="services-main-title">{t.mainTitle}</h1>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-number">{'01.'}</div>
            <h2>{t.service1}</h2>
            <p>{t.service1Desc}</p>
          </div>
          <div className="service-card">
            <div className="service-number">{'02.'}</div>
            <h2>{t.service2}</h2>
            <p>{t.service2Desc}</p>
          </div>
          <div className="service-card">
            <div className="service-number">{'03.'}</div>
            <h2>{t.service3}</h2>
            <p>{t.service3Desc}</p>
          </div>
        </div>
      </section>

      <section id="comparison" className="comparison-section">
        <div className="charts-container">
          <div className="chart-card">
            <h3 className="gradient-text1">{t.holdingTitle}</h3>
            <div className="percentage">2,395%</div>
            <div className="chart">
              <img src={require('../images/chart1.png')} alt="Holding Chart" />
            </div>
          </div>
          <div className="chart-card">
            <h3 className="gradient-text2">{t.tradingTitle}</h3>
            <div className="percentage">9,694%</div>
            <div className="chart">
              <img src={require('../images/chart2.png')} alt="Trading Chart" />
            </div>
          </div>
        </div>
        <div className="comparison-text">
          <h2>{t.comparisonTitle}</h2>
          <h3>{t.comparisonSubtitle}</h3>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-left">
          <p>
            Copyright: 2025 DeepQuant. All rights reserved.
            <br />
            Email: team.toyple@gmail.com
          </p>
        </div>
        <div className="footer-right social-icons">
          <a href="https://x.com/deep_quant" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
          <a href="https://www.threads.com/@deepquant_app" target="_blank" rel="noopener noreferrer"><SiThreads /></a>
          <a href="https://www.instagram.com/deepquant_app/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.tiktok.com/@deepquant_app" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
          <a href="https://www.youtube.com/@DeepQuant-App" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          <a href="https://www.facebook.com/people/DeepQuant/61576278140940/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://coinmarketcap.com/community/profile/Deep_Quant/" target="_blank" rel="noopener noreferrer"><SiCoinmarketcap /></a>
          <a href="https://www.binance.com/en/square/profile/deep_quant" target="_blank" rel="noopener noreferrer"><SiBinance /></a>
        </div>
      </footer>
    </div>
  );
}

export default Home;